import React from 'react';
import * as R from 'ramda';
import {MuiSxProps} from '@practicegenius/pg-ui/src/base/Material/utils/sx-helpers';
import {SxImg} from '@practicegenius/pg-ui/src/base/Material/components/StyleableBaseComponents';
import {makeGetPracticeLogoUrl} from '@practicegenius/domain/src/data/practice';
import {useActivePractice} from '../shared/hooks/useActivePractice';
import {PG_CORE_URL} from '../constants/env';
import {usePhpJs} from '../utils/php-js';
import {useMaybeApi} from '../http/AuthApiProvider';

type Props = {
  sx?: MuiSxProps;
  /** override the default alt text */
  alt?: string;
};

const DEFAULT_PRACTICE_ALT_TEXT = 'Practice Logo';
export const getPracticeLogoUrl = makeGetPracticeLogoUrl({
  coreServiceUrl: PG_CORE_URL,
});

const UnauthenticatedPracticeLogo: React.FC<Props> = ({sx, alt}) => {
  // TODO When we introduce Next.js to the project I expect that we'll scope this even farther:
  //   UnauthenticatedKohanaPracticeLogo and UnauthenticatedNextPracticeLogo.
  const practiceId = usePhpJs(R.pathOr(0, ['practice', 'practice_id']));
  return (
    <SxImg
      sx={sx}
      src={getPracticeLogoUrl(practiceId)}
      alt={alt ?? DEFAULT_PRACTICE_ALT_TEXT}
    />
  );
};

const AuthenitcatedPracticeLogo: React.FC<Props> = ({sx, alt}) => {
  const practice = useActivePractice();
  return (
    <SxImg sx={sx} src={practice.logo} alt={alt ?? DEFAULT_PRACTICE_ALT_TEXT} />
  );
};

/** Renders a stylable logo for the current practice. If there is no practice, no logo will render */
export const PracticeLogo: React.FC<Props> = props => {
  const authApiCtx = useMaybeApi();
  const isAuthenticated = Boolean(authApiCtx);

  return isAuthenticated ? (
    <AuthenitcatedPracticeLogo {...props} />
  ) : (
    <UnauthenticatedPracticeLogo {...props} />
  );
};
